// extracted by mini-css-extract-plugin
export default {"tabIndicator":"BaseVerticalTab_tabIndicator__dVt7W"};